import { toast } from "react-toastify";

export const useNotify = () => (type: "error" | "success", message: string) =>
  toast[type](message);
